export const SUBSCRIPTION_PACKAGES = {
  BASIC: 1,
  PREMIUM: 2,
  UNLIMITED: 3,
  DEMO: 4,
  STARTER: 5,
}
